.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.brand,
.brandCollapsed {
  display: flex;
  gap: 12px;
  align-items: center;
  min-height: 64px;
  padding: 16px 24px;
}

.brandCollapsed {
  justify-content: center;
  padding: 16px;
}

.logo {
  font-size: 28px;
}

.brandTitle {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--ant-color-text);
}

.brandSubtitle {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: var(--ant-color-text-secondary);
}

.menu {
  flex: 1;
  padding-top: 8px;
}
